/**
 * SidebarComponent
 * ----------------
 * Ova komponenta prikazuje bočnu navigacijsku traku.
 * Omogućuje korisniku pristup različitim sekcijama aplikacije putem linkova.
 */
import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../service/auth.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  user$: Observable<any | null>;

  constructor(private authService: AuthService) {
    this.user$ = this.authService.currentUser;
  }


}
